define(
    'connections/wishlist-connection',[
        'jquery',

        'utils/ajax-util',

        'settings',
    ],

    function ($, ajax, settings) {
        /**
         * @class WishListConnection
         */
        return (function () {

            /**
             * @constructor
             */
            function WishListConnection () {}

            WishListConnection.prototype.addProduct = function(sku) {
                return ajax.post(settings.wishListAddApiUrl, { sku: sku });
            };

            WishListConnection.prototype.removeProduct = function(sku) {
                return ajax.delete(settings.wishListRemoveApiUrl, { sku: sku });
            };

            WishListConnection.prototype.resetWishList = function(sku) {
                return ajax.delete(settings.wishListResetApiUrl, { sku: sku });
            };

            WishListConnection.prototype.list = function() {
                return ajax.get(settings.wishListProductsApiUrl);
            };

            return new WishListConnection();
        })();
    }
);

